angular.module('capability-ng-academic-planner').component('blockedSuggestionFixedFooter', {
  transclude: true,
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/blocked_suggestion_fixed_footer/blocked_suggestion_fixed_footer.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/blocked_suggestion_fixed_footer/blocked_suggestion_fixed_footer.ts